import { useEffect, useState } from "react";
import { Loader2, Plus, Trash2, Save } from "lucide-react";
import api from "../lib/apiClient";
import { toast } from "sonner";

export default function AdminMarketplace() {
  const [cats, setCats] = useState(null);

  useEffect(() => { api.get("/marketplace/categories").then((r) => setCats(r.data.categories)).catch(() => setCats([])); }, []);

  const setCat = (i, k, v) => setCats((cs) => cs.map((c, j) => j === i ? { ...c, [k]: v } : c));
  const addCat = () => setCats((cs) => [...cs, { key: "", label: "", metiers: [] }]);
  const rmCat = (i) => setCats((cs) => cs.filter((_, j) => j !== i));

  const save = async () => {
    try {
      const clean = cats.filter((c) => c.key && c.label).map((c) => ({
        key: c.key.toUpperCase().replace(/\s+/g, "_"), label: c.label,
        metiers: Array.isArray(c.metiers) ? c.metiers : String(c.metiers || "").split(",").map((x) => x.trim()).filter(Boolean),
      }));
      await api.put("/marketplace/categories", { categories: clean });
      toast.success("Catégories mises à jour"); setCats(clean);
    } catch (e) { toast.error(e.response?.data?.detail || "Échec"); }
  };

  if (!cats) return <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 text-amber-500 animate-spin" /></div>;

  return (
    <div className="space-y-5" data-testid="admin-marketplace">
      <h1 className="font-display text-3xl font-extrabold">Marketplace — Catégories</h1>
      <p className="text-sm text-zinc-500">Gère les catégories et métiers proposés dans le Marché Cehnura.</p>
      <div className="space-y-2">
        {cats.map((c, i) => (
          <div key={i} className="bg-[#18181E] border border-zinc-800 rounded-2xl p-4 grid sm:grid-cols-[140px_1fr_2fr_auto] gap-2 items-center" data-testid={`cat-row-${i}`}>
            <input value={c.key} onChange={(e) => setCat(i, "key", e.target.value)} placeholder="CLÉ" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            <input value={c.label} onChange={(e) => setCat(i, "label", e.target.value)} placeholder="Libellé" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            <input value={Array.isArray(c.metiers) ? c.metiers.join(", ") : c.metiers} onChange={(e) => setCat(i, "metiers", e.target.value.split(",").map((x) => x.trim()))} placeholder="Métiers (virgules)" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            <button onClick={() => rmCat(i)} className="text-zinc-500 hover:text-red-400"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      <div className="flex gap-3">
        <button onClick={addCat} data-testid="cat-add" className="h-10 px-4 rounded-xl border border-zinc-800 text-sm text-zinc-300 inline-flex items-center gap-1"><Plus className="w-4 h-4" />Ajouter une catégorie</button>
        <button onClick={save} data-testid="cat-save" className="h-10 px-5 rounded-xl gold-gradient text-black font-semibold inline-flex items-center gap-2"><Save className="w-4 h-4" />Enregistrer</button>
      </div>
    </div>
  );
}
